import { useRouter } from 'next/router'

import { inferPageSource } from '@mc/track-event'

export const usePageSource = () => {
  const router = useRouter()

  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : router.pathname

  return inferPageSource(pathname)
}
